export const ApiQuerySpaceTags = Symbol('ApiQuerySpaceTags');
